import { Opaque } from 'ts-essentials';

import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';
import BulkRequest from '@app/features/bulkRequest/types/BulkRequest';
import { ResourceRole } from '@app/features/bulkRequest/types/ResourceRole';

export interface ListBulkRequestsResponse {
  count: number;
  bulkRequests: Pick<
    BulkRequest,
    | 'id'
    | 'title'
    | 'memberId'
    | 'templateId'
    | 'bulkRequestFormId'
    | 'status'
    | 'participant'
    | 'blockSignerAccess'
    | 'taskNumber'
    | 'startedAt'
    | 'updatedAt'
    | 'createdAt'
  >[];
}
export function listBulkRequests(
  workspaceId: string,
  {
    assigned,
    ...params
  }: {
    page: number;
    count: number;
    assigned?: boolean;
  }
): Promise<ListBulkRequestsResponse> {
  return requestApi<ListBulkRequestsResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests`),
    method: 'GET',
    credentials: true,
    params: { ...params, filter: { assigned } },
  }).then((response) => response.data);
}

export function getBulkRequest(workspaceId: string, bulkRequestId: string): Promise<BulkRequest> {
  return requestApi<BulkRequest>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

type Minutes = Opaque<number, 'Minutes'>;
export interface CreateBulkRequestData {
  title: string;
  templateId: string;
  signingDuration?: number;
  roleGrants: ResourceRole[];
}
export interface MutateBulkRequestResponse {
  bulkRequestId: string;
}
export function createBulkRequest(
  workspaceId: string,
  { signingDuration = 14 * 24 * 60 * (1 as Minutes), ...dataRest }: CreateBulkRequestData
): Promise<MutateBulkRequestResponse> {
  return requestApi<MutateBulkRequestResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests`),
    method: 'POST',
    credentials: true,
    data: { ...dataRest, signingDuration },
  }).then((response) => response.data);
}

export function deleteBulkRequest(workspaceId: string, bulkRequestId: string) {
  return requestApi<void>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}`),
    method: 'DELETE',
    credentials: true,
  }).then((response) => response.data);
}
